import { GraphQLClient } from 'graphql-request';

import { environment } from '../../environment';

export const defaultClient = new GraphQLClient(
  `${environment.backendUrl}${environment.graphQLEndpoint}`,
  {
    mode: 'cors',
    credentials: 'include',
  },
);
